import { useRef, useState } from "react";

export const useShowItemsInSection = ({ querySelector }) => {
  const [itemShow, setItemShow] = useState(0);
  const fromShowRef = useRef();
  var timer = null;

  const updateShow = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if ((fromShowRef || {}).current) {
        const el = fromShowRef.current;
        let itemShow = false;
        const list = el.querySelectorAll(querySelector) || [];

        const drop = el.querySelector(".DicesSlider-Drop");
        list.forEach((el, index) => {
          const {left} = el.getBoundingClientRect();
          if (left <= 50) {
            itemShow = index;
          }
        }) 
        drop.offsetWidth + drop.scrollLeft >= drop.scrollWidth - 100
          ? setItemShow(list.length - 1)
          : setItemShow(itemShow || 0);
      }
    }, 100);
  };

  return { fromShowRef, itemShow, updateShow };
};
